export const CUST_ACTIVE = 0;
export const CUST_INACTIVE = 99;
export const CUST_PENDING = 1;
export const CUST_DELETED = 66;

export const CUST_CYOA_DISABLED = 0;
export const CUST_CYOA_ENABLED = 1;
export const CUST_CYOA_OVERRIDE = 2;

export const ORG_LOGO_BRIGHT = 0;
export const ORG_LOGO_DARK = 1;

export const LMS_EMAIL_PASSWORD = 0;
export const LMS_USERNAME_PASSWORD = 1;
export const LMS_EMAIL_ONLY = 2;
export const LMS_USERNAME_ONLY = 3;
export const LMS_SSO = 4;

export const CUSTOM_RENEWAL_PATTERN_DISABLED = 0;
export const CUSTOM_RENEWAL_PATTERN_ENABLED = 1;

export const CAT_CYOA_DISABLED = 0;
export const CAT_CYOA_REQUIRED = 1;
export const CAT_CYOA_OPTIONAL = 2;

export const CAT_TAG_TOPIC = 0;
export const CAT_TAG_THEME = 1;
export const CAT_TAG_DELETED = 99;

export const GROUP_ACTIVE = 0;
export const GROUP_DELETED = 99;

export const PPL_ACTIVE = 0;
export const PPL_DISABLED = 99;

export const REG_NO_INVITE = -1;
export const REG_ACTIVE = 0;
export const REG_NO_CERTIFICATE = 1;
export const REG_COMPLETED = 2;
export const REG_DELETED = 66;
export const REG_DISABLED = 99;

export const REG_SCORM_NO_RETAKE = 0;
export const REG_SCORM_RETAKE = 1;

export const RENEW_NONE = 0;
export const RENEW_AUTOMATIC = 1;
export const RENEW_NEXT_CYCLE = 2;
export const RENEW_FUTURE_CYCLE = 3;
export const RENEW_CUSTOM = 4;

export const SLIDE_TYPE_CONTENT = 0;
export const SLIDE_TYPE_QUIZ = 1;
export const SLIDE_TYPE_SURVEY = 2;
export const SLIDE_TYPE_VIDEO = 3;
export const SLIDE_TYPE_GAME = 4;
export const SLIDE_TYPE_POLICY = 5;
export const SLIDE_TYPE_LINK = 6;
export const SLIDE_TYPE_UPLOAD = 7;
export const SLIDE_TYPE_CHECKBOX = 8;

export const SLIDE_MANUAL_CONTINUE = 0;
export const SLIDE_AUTO_CONTINUE = 1;

export const QUIZ_TYPE_NORMAL = 0;
export const QUIZ_TYPE_SURVEY = 1;
export const QUIZ_TYPE_TRICK = 2;
export const QUIZ_TYPE_MULTI = 3;

export const LANG_ENGLISH = 1;
export const LANG_SPANISH = 2;
export const LANG_FRENCH = 3;
export type HubLanguage = | typeof LANG_ENGLISH | typeof LANG_SPANISH | typeof LANG_FRENCH;

export const INVOICE_OPEN = 0;
export const INVOICE_UNPAID = 1;
export const INVOICE_PAID = 2;
export const INVOICE_ARCHIVED = 99;

export const AUDIO_ACTIVE = 0;
export const AUDIO_UPDATED = 1;
export const AUDIO_REVIEW = 2;

export const DVIDEO_SEGMENT_SIMULTANEOUS = 0;
export const DVIDEO_SEGMENT_PAUSED = 1;
export const DVIDEO_SEGMENT_PAUSE_AFTER = 2;
export const DVIDEO_SEGMENT_BROLL = 3;
export const DVIDEO_SEGMENT_CORE = 4;
export const DVIDEO_SEGMENT_OVERLAY = 5;

export const DVIDEO_OVERLAY_NORMAL = 0;
export const DVIDEO_OVERLAY_SILHOUETTE = 1;

export const DVIDEO_OVERLAY_CHROMA = 0;
export const DVIDEO_OVERLAY_COLOR = 1;

export const DVIDEO_OVERLAY_BOTTOM_RIGHT = 0;
export const DVIDEO_OVERLAY_BOTTOM_LEFT = 1;
export const DVIDEO_OVERLAY_TOP_RIGHT = 2;
export const DVIDEO_OVERLAY_TOP_LEFT = 3;

export const DVIDEO_SOUND_NO_NORMALIZE = 0;
export const DVIDEO_SOUND_NORMALIZE = 1;

export const DVIDEO_SOUND_SOURCE_MATCH = 0;
export const DVIDEO_SOUND_SOURCE_ALT = 1;

export const DVIDEO_TRANSITION_NONE = 0;
export const DVIDEO_TRANSITION_FADE = 1;
export const DVIDEO_TRANSITION_SLIDE = 2;
export const DVIDEO_TRANSITION_SLIDE_FADE = 3;
export const DVIDEO_TRANSITION_SPIN = 4;
export const DVIDEO_TRANSITION_SQUISH = 5;
export const DVIDEO_TRANSITION_SPIN_FADE = 6;
export const DVIDEO_TRANSITION_GENIE = 7;

export const DVIDEO_TRANSITION_SFX_NONE = 0;
export const DVIDEO_TRANSITION_SFX_WHOOSH = 1;
export const DVIDEO_TRANSITION_SFX_SWOOSH = 2;
export const DVIDEO_TRANSITION_SFX_SWIPE = 3;
export const DVIDEO_TRANSITION_SFX_POP = 4;

export const SCRIPT_ACTIVE = 0;
export const SCRIPT_DELETED = 99;

export const SET_ACTIVE = 0;
export const SET_DELETED = 99;

export const PAYMENT_MODE_MONTHLY = 0;
export const PAYMENT_MODE_ANNUAL = 1;
export const PAYMENT_MODE_SUBSCRIPTION = 2;
export const PAYMENT_MODE_ON_DEMAND = 3;

export const AUDIO_SOURCE_S3 = 0;
export const AUDIO_SOURCE_LOCAL = 1;
export const AUDIO_SOURCE_OLD = 2;

export const CON_DELETED = 99;
export const CON_CANCELLED = 98;
export const CON_DRAFT = 4;
export const CON_EXPIRED = 3;
export const CON_PENDING = 2;
export const CON_ACTIVE = 1;
export const CON_INACTIVE = 0;

export const CON_EDIT_INFLEXIBLE = 0;
export const CON_EDIT_FLEXIBLE = 1;

export const CON_GEN_TEMPLATE = 0;
export const CON_GEN_CUSTOM = 1;

export const CON_SIGNED_HAND = 0;
export const CON_SIGNED_DIGITAL = 1;
export const CON_SIGNED_EXTERNAL = 2;

export const CON_EMAILING_INACTIVE = 0;
export const CON_EMAILING_ACTIVE = 1;

export const EMAIL_SCHEDULED = -1;
export const EMAIL_FAILED = 0;
export const EMAIL_SENT = 1;

export const CON_TEMP_CUSTOM = 0;
export const CON_TEMP_SELF_SERVICE = 1;

export const COUNTRY_US = 1;
export const COUNTRY_UK = 2;
export const COUNTRY_CAN = 3;

export const REN_LIST_UPCOMING = 0;
export const REN_LIST_PREVIOUS = 1;
export const REN_LIST_ALL_DATED = 2;
export const REN_LIST_ALL = 3;

export const ROLE_TYPE_ADMIN = 0;
export const ROLE_TYPE_PRIMARY = 1;

export const ADMIN_ROLE_ACTIVE = 0;
export const ADMIN_ROLE_DELETED = 99;

export const TICKET_STUCK = 0;
export const TICKET_MISC = 1;

export const JURISDICTION_ALL = 0;

export const COURSE_ROLE_BOTH = 0;
export const COURSE_ROLE_STAFF = 1;
export const COURSE_ROLE_SUPERVISOR = 2;

export const ADMIN_ACTIVE = 0;
export const ADMIN_DELETED = 99;

export const AFF_ACTIVE = 0;
export const AFF_DISABLED = 66;
export const AFF_DELETED = 99;

export const PARTNER_LINK_CUSTOM = 0;
export const PARTNER_LINK_SIGNUP = 1;

export const PARTNER_ACTIVE = 0;
export const PARTNER_DISABLED = 66;
export const PARTNER_DELETED = 99;

export const TAB_ROSTER = 'roster';
export const TAB_SETTINGS = 'settings';
export const TAB_TRAINING_LOGIN = 'entry';
export const TAB_BILLING = 'charges';
export const TAB_BRANCHES = 'branches';
export const TAB_BRANCHES_SEARCH = 'branches_search';
export const TAB_ACTIVATION = 'activation';
export const TAB_ADMINS = 'admins';
export const TAB_COURSE_REVIEW = 'course_review';
export const TAB_COURSE_BUILDER = 'course_builder';
export const TAB_SERVICES = 'services';

export const HUB_TAB_TRAININGS = 'trainings';
export const HUB_TAB_ACCOUNT = 'account';
export const HUB_TAB_HELP = 'help';

export const COURSE_REVIEW_DISABLED = 0;
export const COURSE_REVIEW_READ = 1;
export const COURSE_REVIEW_WRITE = 2;

export const SLIDE_REVIEW_UNAPPROVED = 0;
export const SLIDE_REVIEW_APPROVED = 1;

export const CAT_UNAPPROVED = 0;
export const CAT_APPROVED_CONFIG = 1;
export const CAT_APPROVED_FULL = 2;

export const CAT_UNEDITED = 0;
export const CAT_EDITED_OUTSIDE = 1;
export const CAT_EDITED_CONFIG = 2;
export const CAT_EDITED_BOTH = 3;

export const SKU_SETUP_COST = 1;
export const SKU_TRAINING_PREPURCHASE = 2;
export const SKU_USER_REGISTRATION = 3;
export const SKU_CREDIT = 4;
export const SKU_REPLENISHMENT_COST = 5;
export const SKU_CHARGE_ERROR = 6;
export const SKU_MONTHLY = 7;
export const SKU_CC_TRANSACTION_FEE = 8;
export const SKU_REFUND = 9;
export const SKU_INVOICE = 10;
export const SKU_BALANCE_FORWARD = 11;
export const SKU_MISCELLANEOUS = 12;
export const SKU_ACH_TRANSACTION_FEE = 13;
export const SKU_ADJUSTMENT = 14;
export const SKU_SUBSCRIPTION = 15;

export const DOWNTIME_PENDING = 0;
export const DOWNTIME_ACTIVE = 1;
export const DOWNTIME_FINISHED = 2;
export const DOWNTIME_VIMEO = 3;
export const DOWNTIME_WARNING_DB = 4;
export const DOWNTIME_WARNING_COURSE = 5;
export const DOWNTIME_WARNING_BOTH = 6;
export const GLOBAL_MESSAGE_DB = 7;
export const GLOBAL_MESSAGE_COURSE = 8;
export const GLOBAL_MESSAGE_BOTH = 9;
export const DOWNTIME_CANCELLED = 99;